
import {COPY_STRINGS} from './translatedCopy';

// A few notes about our string constants:
// 1. You'll see some commented out lines. These are left in for when we have the student's name.
//    Until that time, we want to preserve the intent to start using their name during the dialog.
// 2. There are some tokens in these strings that will be replaced by higher-order functions.
//    The convention is ${pX} where X = 0 for the first replacement, 1 for the 2nd, etc.
//    See library.js for the method that does the replacement. Why not ES6 templates, you ask?
//    Long story short - they try to resolve the template too early in the lifecycle for us to use
//    them in a file like this where we want to keep our strings all in one place.

export const rhymes = [
  {word: "throughout", rhyme: "blackout"},
  {word: "remain", rhyme: "explain"},
  {word: "over", rhyme: "clover"},
  {word: "egg", rhyme: "beg"},
  {word: "tiny", rhyme: "shiny"},
  {word: "round", rhyme: "mound"},
  {word: "gets", rhyme: "jets"},
  {word: "growth", rhyme: "both"},
  {word: "patches", rhyme: "catches"},
  {word: "see", rhyme: "bee"},
  {word: "find", rhyme: "mind"},
  {word: "lay", rhyme: "say"},
  {word: "more", rhyme: "store"},
  {word: "new", rhyme: "few"},
  {word: "places", rhyme: "faces"},
  {word: "live", rhyme: "give"},
  {word: "worm", rhyme: "squirm"},
  {word: "warm", rhyme: "swarm"},
  {word: "usually", rhyme: "causally"},
  {word: "imago", rhyme: "chicago"},
  {word: "insect", rhyme: "dissect"},
  {word: "summer", rhyme: "drummer"},
  {word: "hair", rhyme: "pair"},
  {word: "warmer", rhyme: "former"},
  {word: "state", rhyme: "gate"},
  {word: "shape", rhyme: "grape"},
  {word: "stripes", rhyme: "gripes"},
  {word: "mates", rhyme: "hates"},
  {word: "tissues", rhyme: "issues"},
  {word: "larva", rhyme: "marva"},
  {word: "attached", rhyme: "matched"},
  {word: "stages", rhyme: "pages"},
  {word: "four", rhyme: "pour"},
  {word: "migrates", rhyme: "primates"},
  {word: "winter", rhyme: "printer"},
  {word: "object", rhyme: "project"},
  {word: "reproductive", rhyme: "reconstructive"},
  {word: "leaf", rhyme: "reef"},
  {word: "adult", rhyme: "insult"},
  {word: "enclose", rhyme: "bulldoze"},
  {word: "encloses", rhyme: "opposes"},
  {word: "pattern", rhyme: "saturn"},
  {word: "green", rhyme: "screen"},
  {word: "warmer", rhyme: "former"},
  {word: "spring", rhyme: "sing"},
  {word: "round", rhyme: "sound"},
  {word: "separate", rhyme: "speculate"},
  {word: "blend", rhyme: "spend"},
  {word: "into", rhyme: "redo"},
  {word: "broken", rhyme: "spoken"},
  {word: "sheds", rhyme: "spreads"},
  {word: "spine", rhyme: "swine"},
  {word: "spines", rhyme: "lines"},
  {word: "body", rhyme: "shoddy"},
  {word: "growing", rhyme: "flowing"},
  {word: "skin", rhyme: "grin"},
  {word: "called", rhyme: "stalled"},
  {word: "stem", rhyme: "them"},
  {word: "brown", rhyme: "town"},
  {word: "transformation", rhyme: "translation"},
  {word: "colonizes", rhyme: "utilizes"},
  {word: "life", rhyme: "wife"},
  {word: "five", rhyme: "dive"},
  {word: "little", rhyme: "brittle"},
  {word: "once", rhyme: "dunce"},
  {word: "time", rhyme: "lime"},
  {word: "there", rhyme: "where"},
  {word: "sitting", rhyme: "hitting"},
  {word: "might", rhyme: "fight"},
  {word: "have", rhyme: "calve"},
  {word: "sometimes", rhyme: "enzymes"},
  {word: "intended", rhyme: "pretended"},
  {word: "plate", rhyme: "skate"},
  {word: "first", rhyme: "thirst"},
  {word: "one", rhyme: "done"},
  {word: "said", rhyme: "head"},
  {word: "table", rhyme: "fable"},
  {word: "great", rhyme: "plate"},
  {word: "this", rhyme: "kiss"},
  {word: "fifth", rhyme: "smith"},
  {word: "smell", rhyme: "swell"},
  {word: "pie", rhyme: "lie"},
  {word: "third", rhyme: "bird"},
  {word: "love", rhyme: "glove"},
  {word: "fourth", rhyme: "north"},
  {word: "why", rhyme: "sky"},
  {word: "let's", rhyme: "gets"},
  {word: "run", rhyme: "fun"},
  {word: "before", rhyme: "ignore"},
  {word: "people", rhyme: "steeple"},
  {word: "come", rhyme: "some"},
  {word: "then", rhyme: "when"},
  {word: "ding", rhyme: "ring"},
  {word: "dong", rhyme: "gong"},
  {word: "went", rhyme: "sent"},
  {word: "all", rhyme: "tall"},
  {word: "ran", rhyme: "pan"},
  {word: "went", rhyme: "dent"},
  {word: "people", rhyme: "steeple"},
  {word: "turkey", rhyme: "jerkey"},
  {word: "doorbell", rhyme: "fairwell"},
  {word: "ask", rhyme: "task"},
  {word: "away", rhyme: "play"},
  {word: "being", rhyme: "skiing"},
  {word: "brother", rhyme: "mother"},
  {word: "cans", rhyme: "pans"},
  {word: "cat", rhyme: "hat"},
  {word: "center", rhyme: "inventor"},
  {word: "cut", rhyme: "hut"},
  {word: "dad", rhyme: "sad"},
  {word: "dry", rhyme: "cry"},
  {word: "ears", rhyme: "tears"},
  {word: "far ", rhyme: "bar"},
  {word: "fun", rhyme: "sun"},
  {word: "good", rhyme: "wood"},
  {word: "hammer", rhyme: "stammer"},
  {word: "help", rhyme: "yelp"},
  {word: "hold", rhyme: "told"},
  {word: "hole", rhyme: "pole"},
  {word: "inside", rhyme: "decide"},
  {word: "job", rhyme: "mob"},
  {word: "jump", rhyme: "bump"},
  {word: "keep", rhyme: "beep"},
  {word: "knot", rhyme: "pot"},
  {word: "know", rhyme: "grow"},
  {word: "lap", rhyme: "cap"},
  {word: "likes", rhyme: "hikes"},
  {word: "long", rhyme: "song"},
  {word: "Look", rhyme: "cook"},
  {word: "mom", rhyme: "tom"},
  {word: "my", rhyme: "by"},
  {word: "nail", rhyme: "pail"},
  {word: "nap", rhyme: "lap"},
  {word: "naps", rhyme: "taps"},
  {word: "need", rhyme: "feed"},
  {word: "new", rhyme: "chew"},
  {word: "older", rhyme: "folder"},
  {word: "other", rhyme: "mother"},
  {word: "pal", rhyme: "gal"},
  {word: "pet", rhyme: "get"},
  {word: "play", rhyme: "say"},
  {word: "punch", rhyme: "hunch"},
  {word: "rat", rhyme: "fat"},
  {word: "ready", rhyme: "steady"},
  {word: "really", rhyme: "chilly"},
  {word: "rim", rhyme: "him"},
  {word: "rug", rhyme: "hug"},
  {word: "run", rhyme: "fun"},
  {word: "runs", rhyme: "buns"},
  {word: "said", rhyme: "bread"},
  {word: "Sam", rhyme: "ham"},
  {word: "see", rhyme: "bee"},
  {word: "simple", rhyme: "pimple"},
  {word: "sister", rhyme: "blister"},
  {word: "sit", rhyme: "bit"},
  {word: "soap", rhyme: "rope"},
  {word: "some", rhyme: "come"},
  {word: "string", rhyme: "ring"},
  {word: "sun", rhyme: "fun"},
  {word: "talk", rhyme: "chalk"},
  {word: "talking", rhyme: "walking"},
  {word: "tape", rhyme: "grape"},
  {word: "telephone", rhyme: "postpone"},
  {word: "things", rhyme: "wings"},
  {word: "tie", rhyme: "lie"},
  {word: "tightly", rhyme: "lightly"},
  {word: "tin", rhyme: "bin"},
  {word: "walk", rhyme: "talk"},
  {word: "warm", rhyme: "swarm"},
  {word: "wash", rhyme: "squash"},
  {word: "adults", rhyme: "insults"},
  {word: "after", rhyme: "laughter"},
  {word: "air", rhyme: "hair"},
  {word: "alike", rhyme: "bike"},
  {word: "another", rhyme: "brother"},
  {word: "around", rhyme: "astound"},
  {word: "axes", rhyme: "taxes"},
  {word: "begin", rhyme: "within"},
  {word: "better", rhyme: "letter"},
  {word: "blink", rhyme: "stink"},
  {word: "blobs", rhyme: "gobs"},
  {word: "bottom", rhyme: "autumn"},
  {word: "boys", rhyme: "toys"},
  {word: "bumpy", rhyme: "grumpy"},
  {word: "butterfly", rhyme: "satisfy"},
  {word: "carries", rhyme: "berries"},
  {word: "carry", rhyme: "berry"},
  {word: "cars", rhyme: "bars"},
  {word: "catch", rhyme: "patch"},
  {word: "chase", rhyme: "vase"},
  {word: "chased", rhyme: "traced"},
  {word: "chasing", rhyme: "facing"},
  {word: "chop", rhyme: "crop"},
  {word: "clap", rhyme: "slap"},
  {word: "cold", rhyme: "bold"},
  {word: "cool", rhyme: "pool"},
  {word: "dark", rhyme: "bark"},
  {word: "deserts", rhyme: "outskirts"},
  {word: "drive", rhyme: "hive"},
  {word: "eat", rhyme: "seat"},
  {word: "eggs", rhyme: "legs"},
  {word: "end", rhyme: "spend"},
  {word: "even", rhyme: "steven"},
  {word: "ever", rhyme: "never"},
  {word: "everyday", rhyme: "anyway"},
  {word: "everyone", rhyme: "grandson"},
  {word: "fact", rhyme: "cracked"},
  {word: "far", rhyme: "star"},
  {word: "feed", rhyme: "seed"},
  {word: "feeding", rhyme: "speeding"},
  {word: "feet", rhyme: "street"},
  {word: "female", rhyme: "email"},
  {word: "fire", rhyme: "tire"},
  {word: "fire", rhyme: "tire"},
  {word: "fires", rhyme: "hires"},
  {word: "fish", rhyme: "dish"},
  {word: "flames", rhyme: "james"},
  {word: "following", rhyme: "swallowing"},
  {word: "food", rhyme: "mood"},
  {word: "food", rhyme: "mood"},
  {word: "form", rhyme: "storm"},
  {word: "frog", rhyme: "dog "},
  {word: "frogs", rhyme: "dogs"},
  {word: "from", rhyme: " "},
  {word: "funny", rhyme: "bunny"},
  {word: "gate", rhyme: "mate"},
  {word: "gear", rhyme: "fear"},
  {word: "gills", rhyme: "bills"},
  {word: "glad", rhyme: "lad"},
  {word: "goat", rhyme: "vote"},
  {word: "goats", rhyme: "votes"},
  {word: "grow", rhyme: "throw"},
  {word: "grownup", rhyme: "backup"},
  {word: "grows", rhyme: "shows"},
  {word: "hairs", rhyme: "stairs"},
  {word: "hatch", rhyme: "catch"},
  {word: "hear", rhyme: "ear"},
  {word: "heard", rhyme: "nerd"},
  {word: "high", rhyme: "sigh"},
  {word: "holes", rhyme: "poles"},
  {word: "hoses", rhyme: "roses"},
  {word: "however", rhyme: "forever"},
  {word: "insects", rhyme: "objects"},
  {word: "just", rhyme: "gust"},
  {word: "kept", rhyme: "wept"},
  {word: "kinds", rhyme: "minds"},
  {word: "ladder", rhyme: "madder"},
  {word: "land", rhyme: "hand"},
  {word: "leave", rhyme: "weave"},
  {word: "leaves", rhyme: "weaves"},
  {word: "legs", rhyme: "eggs"},
  {word: "like", rhyme: "spike"},
  {word: "look", rhyme: "hook"},
  {word: "looks", rhyme: "cooks"},
  {word: "lot", rhyme: "hot"},
  {word: "lots", rhyme: "spots"},
  {word: "loud", rhyme: "cloud"},
  {word: "lunch", rhyme: "hunch"},
  {word: "many", rhyme: "any"},
  {word: "masks", rhyme: "asks"},
  {word: "middle", rhyme: "riddle"},
  {word: "mike", rhyme: "bike"},
  {word: "moist", rhyme: "hoist"},
  {word: "name", rhyme: "fame"},
  {word: "near", rhyme: "dear"},
  {word: "often", rhyme: "soften"},
  {word: "oh", rhyme: "no"},
  {word: "order", rhyme: "border"},
  {word: "pen", rhyme: "den"},
  {word: "peter", rhyme: "meter"},
  {word: "petting", rhyme: "getting"},
  {word: "picnic", rhyme: "lipstick"},
  {word: "pike", rhyme: "hike"},
  {word: "pine", rhyme: "dine"},
  {word: "pine", rhyme: "dine"},
  {word: "poke", rhyme: "smoke"},
  {word: "poles", rhyme: "holes"},
  {word: "ponds", rhyme: "bonds"},
  {word: "protect", rhyme: "correct"},
  {word: "protection", rhyme: "correction"},
  {word: "provide", rhyme: "decide"},
  {word: "provides", rhyme: "decides"},
  {word: "push", rhyme: "bush"},
  {word: "reach", rhyme: "teach"},
  {word: "redwoods", rhyme: "backwoods"},
  {word: "replace", rhyme: "erase"},
  {word: "roof", rhyme: "goof"},
  {word: "sam", rhyme: "clam"},
  {word: "say", rhyme: "pay"},
  {word: "sees", rhyme: "bees"},
  {word: "shapes", rhyme: "grapes"},
  {word: "shoot", rhyme: "boot"},
  {word: "shouted", rhyme: "routed"},
  {word: "sits", rhyme: "hits"},
  {word: "sizes", rhyme: "rises"},
  {word: "small", rhyme: "mall"},
  {word: "smoke", rhyme: "broke"},
  {word: "spend", rhyme: "blend"},
  {word: "spray", rhyme: "stray"},
  {word: "stage", rhyme: "page"},
  {word: "sticky", rhyme: "tricky"},
  {word: "stop", rhyme: "crop"},
  {word: "strings", rhyme: "things"},
  {word: "sure", rhyme: "cure"},
  {word: "swallow", rhyme: "hollow"},
  {word: "swim", rhyme: "grim"},
  {word: "tadpole", rhyme: "manhole"},
  {word: "tadpoles", rhyme: "patrols"},
  {word: "tail", rhyme: "sail"},
  {word: "tails", rhyme: "sails"},
  {word: "take", rhyme: "make"},
  {word: "tall", rhyme: "mall"},
  {word: "tanks", rhyme: "thanks"},
  {word: "than", rhyme: "fan"},
  {word: "them", rhyme: "stem"},
  {word: "they", rhyme: "grey"},
  {word: "thin", rhyme: "skin"},
  {word: "thorns", rhyme: "horns"},
  {word: "those", rhyme: "chose"},
  {word: "though", rhyme: "dough"},
  {word: "throats", rhyme: "boats"},
  {word: "thunder", rhyme: "under"},
  {word: "times", rhyme: "crimes"},
  {word: "tired", rhyme: "hired"},
  {word: "toad", rhyme: "road"},
  {word: "toads", rhyme: "loads"},
  {word: "toolbox", rhyme: "outfox"},
  {word: "tools", rhyme: "fools"},
  {word: "tree", rhyme: "free"},
  {word: "trees", rhyme: "flees"},
  {word: "truck", rhyme: "stuck"},
  {word: "trucks", rhyme: "ducks"},
  {word: "types", rhyme: "stripes"},
  {word: "upon", rhyme: "pompon"},
  {word: "very", rhyme: "berry"},
  {word: "walls", rhyme: "halls"},
  {word: "way", rhyme: "day"},
  {word: "ways", rhyme: "stays"},
  {word: "wear", rhyme: "tear"},
  {word: "weather", rhyme: "feather"},
  {word: "weeks", rhyme: "cheeks"},
  {word: "wheels", rhyme: "heels"},
  {word: "whole", rhyme: "stole"},
  {word: "with", rhyme: "fifth"},
  {word: "wondered", rhyme: "plundered"},
  {word: "year", rhyme: "fear"},
  {word: "yelled", rhyme: "smelled"},
  {word: "yellow", rhyme: "fellow"},
  {word: "zoo", rhyme: "too"},
  {word: "alone", rhyme: "jawbone"},
  {word: "baby", rhyme: "maybe"},
  {word: "bed", rhyme: "head"},
  {word: "big", rhyme: "pig"},
  {word: "climb ", rhyme: "slime"},
  {word: "cry", rhyme: "fly"},
  {word: "enough", rhyme: "handcuff"},
  {word: "friends", rhyme: "spend"},
  {word: "grandpa", rhyme: "outlaw"},
  {word: "happy", rhyme: "snappy"},
  {word: "hug", rhyme: "bug"},
  {word: "lift", rhyme: "gift"},
  {word: "lives", rhyme: "gives"},
  {word: "mom", rhyme: "tom"},
  {word: "pick", rhyme: "lick"},
  {word: "plays", rhyme: "days"},
  {word: "punch", rhyme: "bunch"},
  {word: "right", rhyme: "fight"},
  {word: "rim", rhyme: "swim"},
  {word: "rivers", rhyme: "shivers"},
  {word: "round", rhyme: "pound"},
  {word: "rug", rhyme: "hug"},
  {word: "run", rhyme: "bun"},
  {word: "runs", rhyme: "buns"},
  {word: "said", rhyme: "sled"},
  {word: "sam", rhyme: "clam"},
  {word: "say", rhyme: "pay"},
  {word: "see", rhyme: "bee"},
  {word: "shanu", rhyme: "redo"},
  {word: "she", rhyme: "see"},
  {word: "sing", rhyme: "ring"},
  {word: "size", rhyme: "rise"},
  {word: "sizes", rhyme: "rises"},
  {word: "sleep", rhyme: "peep"},
  {word: "smiles", rhyme: "mile"},
  {word: "smiles", rhyme: "miles"},
  {word: "smooth", rhyme: "soothe"},
  {word: "too", rhyme: "boo"},
  {word: "trunks", rhyme: "bunks"},
  {word: "wake", rhyme: "bake"},
  {word: "what", rhyme: "shut"},
  {word: "you", rhyme: "moo"},
];

export const stopWords = {
  proficient: [
    'back',
    'big',
    'call',
    'came',
    'can',
    'cat',
    'come',
    'dad',
    'day',
    'dog',
    'get',
    'go',
    'got',
    'going',
    'last',
    'made',
    'make',
    'mom',
    'new',
    'next',
    'now',
    'old',
    'play',
    'put',
    'said',
    'see',
    'take',
    'three',
    'time',
    'two',
    'us',
    'went',
    'will',
    'yes',
    'a',
    'all',
    'am',
    'an',
    'and',
    'any',
    'are',
    'aren\'t',
    'as',
    'at',
    'be',
    'because',
    'been',
    'both',
    'but',
    'by',
    'can\'t',
    'did',
    'didn\'t',
    'do',
    'does',
    'doing',
    'don\'t',
    'down',
    'during',
    'each',
    'few',
    'for',
    'from',
     'Goes',
    'had',
    'hadn\'t',
    'has',
    'have',
    'having',
    'he',
    'he\'d',
    'he\'ll',
    'he\'s',
    'her',
    'here',
    'here\'s',
    'hers',
    'him',
    'his',
    'how',
    'how\'s',
    'i',
    'i\'d',
    'i\'ll',
    'i\'m',
    'i\'ve',
    'if',
    'in',
    'into',
    'is',
    'isn\'t',
    'it',
    'it\'s',
    'its',
    'let\'s',
    'me',
    'more',
    'most',
    'my',
    'no',
    'nor',
    'not',
    'of',
    'off',
    'on',
    'One',
    'once',
    'only',
    'or',
    'our',
    'ours',
    'out',
    'over',
    'own',
    'same',
    'she',
    'she\'d',
    'she\'ll',
    'she\'s',
    'should',
    'so',
    'some',
    'such',
    'than',
    'that',
    'that\'s',
    'the',
    'them',
    'then',
    'they',
    'this',
    'those',
    'to',
    'up',
    'very',
    'was',
    'we',
    'we\'d',
    'we\'ll',
    'we\'re',
    'we\'ve',
    'were',
    'what',
    'what\'s',
    'when',
    'when\'s',
    'who',
    'who\'s',
    'why',
    'why\'s',
    'with',
    'won\'t',
    'yet',
    'you',
    'you\'d',
    'your',
    'yours',
  ],
  capable: [
    'back',
    'big',
    'call',
    'came',
    'can',
    'cat',
    'come',
    'dad',
    'day',
    'dog',
    'get',
    'go',
    'got',
    'last',
    'look',
    'made',
    'make',
    'mom',
    'new',
    'next',
    'now',
    'old',
    'play',
    'put',
    'said',
    'see',
    'take',
    'three',
    'time',
    'two',
    'us',
    'went',
    'will',
    'yes',
    'a',
    'all',
    'am',
    'an',
    'and',
    'any',
    'are',
    'as',
    'at',
    'be',
    'been',
    'both',
    'but',
    'by',
    'can\'t',
    'could',
    'did',
    'didn\'t',
    'do',
    'does',
    'doesn\'t',
    'don\'t',
    'down',
    'each',
    'few',
    'for',
    'from',
    'go',
    'goes',
    'had',
    'hadn\'t',
    'has',
    'he',
    'he\'d',
    'he\'ll',
    'he\'s',
    'her',
    'here',
    'here\'s',
    'hers',
    'him',
    'his',
    'how',
    'how\'s',
    'i',
    'i\'d',
    'i\'ll',
    'i\'m',
    'i\'ve',
    'if',
    'in',
    'into',
    'is',
    'isn\'t',
    'it',
    'it\'s',
    'its',
    'let\'s',
    'me',
    'more',
    'most',
    'my',
    'no',
    'nor',
    'not',
    'of',
    'off',
    'on',
	'one',
    'once',
    'only',
    'or',
    'our',
    'ours',
    'out',
    'over',
    'own',
    'same',
    'she',
    'she\'d',
    'she\'ll',
    'she\'s',
    'so',
    'some',
    'such',
    'than',
    'that',
    'that\'s',
    'the',
    'them',
    'then',
    'they',
    'this',
    'to',
    'too',
    'up',
    'us',
    'very',
    'was',
    'we',
    'we\'d',
    'we\'ll',
    'we\'re',
    'we\'ve',
    'were',
    'what',
    'what\'s',
    'when',
    'when\'s',
    'who',
    'who\'s',
    'why',
    'why\'s',
    'with',
    'won\'t',
    'would',
    'yet',
    'you',
    'you\'d',
    'you\'ll',
    'you\'re',
    'you\'ve',
    'your',
    'yours',
  ],
  beginner: [
    'us',
    'a',
    'am',
    'an',
    'and',
    'are',
    'as',
    'at',
    'be',
    'by',
    'but',
    'did',
    'do',
    'for',
    'go',
    'had',
    'has',
    'he',
    'i',
    'if',
    'in',
    'is',
    'it',
    'it\'s',
    'its',
    'me',
    'my',
    'no',
    'not',
    'of',
    'on',
    'or',
    'so',
    'the',
    'to',
    'too',
    'up',
    'us',
    'was',
    'we',
    'you',
   ]
};

export const spanishStopWords = [
  'de',
  'la',
  'que',
  'el',
  'en',
  'y',
  'a',
  'los',
  'del',
  'se',
  'las',
  'por',
  'un',
  'con',
  'no',
  'una',
  'su',
  'al',
  'lo',
  'más',
  'sus',
  'le',
  'ya',
  'o',
  'sí',
  'muy',
  'sin',
  'me',
  'hay',
  'nos',
  'uno',
  'les',
  'ni',
  'ese',
  'eso',
  'e',
  'mí',
  'qué',
  'yo',
  'él',
  'esa',
  'mi',
  'mis',
  'tú',
  'te',
  'ti',
  'tu',
  'tus',
  'os',
  'mío',
  'mía',
  'he',
  'has',
  'ha',
  'han',
  'soy',
  'es',
  'son',
  'sea',
  'era',
  'fui',
  'fue'
];